import { adminRoles } from "../utils/constant";
import useAccountQuery from "./useAccountQuery";
import useIsRole from "./useIsRole";

// use for Appsmen Admin and Branch Admin ( owner )

const useIsAdmin = (customRoles?: string[]) => {
  const { data: account } = useAccountQuery();
  const isAdmin = useIsRole(account?.roles, [
    ...adminRoles,
    ...(customRoles ?? []),
  ]);
  return isAdmin;
};

export default useIsAdmin;
